<template>
  <v-dialog
    v-model="modal"
    ref="dialog"
    scrollable
    :persistent="persistent"
    eager
    v-bind="$attrs"
    @keydown.esc="$emit('close')"
  >
    <v-card class="app-card card-borderless">
      <v-toolbar v-if="isShowHeader" :dark="headerDark" :color="headerColor" >
        <div :style="styleForHeaderContainer" :class="classHeader">
          <div v-if="isShowHeaderClose">
            <slot name="header-close">
              <gg-btn icon dark elevation="0" @click="$emit('close')" aria-label="Close">
                <v-icon>mdi-close</v-icon>
              </gg-btn>
            </slot>
          </div>
          <div>
            <slot name="header"></slot>
          </div>
        </div>
      </v-toolbar>
      <v-card-title v-if="isShowTitle">
        <div :style="styleForTitleContainer" :class="classTitle">
          <slot name="title"></slot>
          <div v-if="isShowTitleClose">
            <slot name="title-close">
              <gg-btn icon dark elevation="0" @click="$emit('close')" aria-label="Close">
                <v-icon>mdi-close</v-icon>
              </gg-btn>
            </slot>
          </div>
        </div>
      </v-card-title>

      <v-card-text class="pt-2 pb-3" v-if="isBodySlotActive">
        <slot name="body"></slot>
      </v-card-text>
      <v-card-actions v-if="isShowFooter" :style="styleForFooterContainer" :class="classFooter">
        <slot name="footer">
          <gg-btn v-bind="footerCloseAttrs" text @click="$emit('close')">
            {{ footerCloseText }}
          </gg-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GGAppModal',
  props: {
    headerDark: {
      type: Boolean,
      default: true,
    },
    headerColor: {
      type: String,
      default: 'header',
    },
    isActive: {
      type: Boolean,
    },
    closeButtonPositions: {
      type: Array,
      default: () => ['header'],
    },
    footerCloseAttrs: {
      type: Object,
      default: () => ({
        outlined: false,
        color: 'primary',
      }),
    },
    footerCloseText: {
      type: String,
      default: 'Close',
    },
    styleHeader: {
      type: Object,
      default: () => {}
    },
    classHeader: {
      type: String,
      default: () => '',
    },
    styleFooter: {
      type: Object,
      default: () => {},
    },
    classFooter: {
      type: String,
      default: () => '',
    },
    styleTitle: {
      type: Object,
      default: () => {}
    },
    classTitle: {
      type: String,
      default: () => '',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      modal: false,
      styleForTitleContainerDefault: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        flexDirection: 'row',
      },
      styleForHeaderContainerDefault: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        flexDirection: 'row-reverse',
      },
      styleForFooterContainerDefault: {
        display: 'flex',
        justifyContent: 'end',
        width: '100%',
        alignItems: 'center',
        flexDirection: 'row',
      },
    }
  },
  created () {
    this.modal = this.isActive
  },
  mounted () {
    const modals = document.querySelectorAll('.v-dialog__content')

    modals.forEach(item => item.setAttribute('role', 'dialog'))
  },
  watch: {
    isActive: function (val) {
      this.modal = val
    }
  },
  computed: {
    isShowHeader () {
      return this.$slots.header !== undefined || this.$slots['header-close'] !== undefined || this.closeButtonPositions.includes('header')
    },
    isShowHeaderClose () {
      return this.$slots['header-close'] !== undefined || this.closeButtonPositions.includes('header')
    },
    isShowTitle () {
      return this.$slots.title !== undefined || this.$slots['header-close'] !== undefined || this.closeButtonPositions.includes('title')
    },
    isShowTitleClose () {
      return this.$slots['header-close'] !== undefined || this.closeButtonPositions.includes('title')
    },
    isBodySlotActive () {
      return this.$slots.body !== undefined
    },
    isShowFooter () {
      return this.$slots.footer !== undefined || this.closeButtonPositions.includes('footer')
    },
    styleForFooterContainer () {
      return Object.assign(this.styleForFooterContainerDefault, this.styleFooter)
    },
    styleForHeaderContainer () {
      return Object.assign(this.styleForHeaderContainerDefault, this.styleHeader)
    },
    styleForTitleContainer () {
      return Object.assign(this.styleForTitleContainerDefault, this.styleTitle)
    },
  }
}
</script>
